/* Retouches HOPER, 14/10/2026.
   Revelation de la bande « real touch » quand elle entre dans l'ecran.
   Regle de prudence : la classe `hoper-rt-js` arme l'animation, et elle n'est
   posee que si tout le reste suit. Sans elle, le CSS laisse le bloc visible.
   Un filet de securite revele quoi qu'il arrive au bout de deux secondes. */
(function () {
  function demarrer() {
    var cible = document.querySelector('[id$="__text_with_icons_q66Rx4"]');
    if (!cible) return;
    if (!('IntersectionObserver' in window)) return;   /* on laisse visible */
    cible.classList.add('hoper-rt-js');
    var reveler = function () { cible.classList.add('hoper-rt-vu'); };
    var obs = new IntersectionObserver(function (entrees) {
      for (var i = 0; i < entrees.length; i++) {
        if (entrees[i].isIntersecting) { reveler(); obs.disconnect(); return; }
      }
    }, { threshold: 0.15, rootMargin: '0px 0px -5% 0px' });
    obs.observe(cible);
    setTimeout(reveler, 2000);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
